<!-- Title -->
@if (showTitle) {
  <div class="flex items-start justify-between gap-2 mb-3">
    <h3 class="font-semibold text-gray-900 line-clamp-2" [title]="title">
      {{ title }}
    </h3>
    <ng-content select="[slot=actions]"></ng-content>
  </div>
}

<!-- Tags -->
<div class="flex flex-wrap items-center gap-1.5 mb-2">
  <span
    class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 whitespace-nowrap shrink-0"
  >
    <lucide-icon [img]="icons.GraduationCap" class="w-3 h-3"></lucide-icon>
    Grade {{ assignment.grade }}
  </span>
  @if (tier1Name) {
    <span
      class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-purple-50 text-purple-700 whitespace-nowrap shrink-0"
    >
      <lucide-icon [img]="icons.BookOpen" class="w-3 h-3"></lucide-icon>
      {{ tier1Name }}
    </span>
  }
  @if (assignment.subject) {
    <span
      class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700 whitespace-nowrap shrink-0"
    >
      <lucide-icon [img]="icons.Bookmark" class="w-3 h-3"></lucide-icon>
      {{ assignment.subject }}
    </span>
  }
</div>

<!-- Times & status -->
<div
  class="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-sm text-gray-500 mb-3"
>
  @if (showCreatedAt && assignment.createdAt) {
    <span class="flex items-center gap-1.5">
      <lucide-icon
        [img]="icons.Clock"
        class="w-4 h-4 text-gray-400"
      ></lucide-icon>
      {{ assignment.createdAt | relativeTime }}
    </span>
  }
  @if (isPublished) {
    <span class="flex items-center gap-1.5">
      <lucide-icon
        [img]="icons.CalendarClock"
        class="w-4 h-4 text-gray-400"
      ></lucide-icon>
      {{ dueDateLabel }}
    </span>
    <span class="flex items-center gap-1.5">
      <lucide-icon
        [img]="icons.Hourglass"
        class="w-4 h-4 text-gray-400"
      ></lucide-icon>
      {{ timeLimitLabel }}
    </span>
  } @else {
    <span
      class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-50 text-amber-700"
    >
      <lucide-icon [img]="icons.Pencil" class="w-3 h-3"></lucide-icon>
      Draft
    </span>
  }
</div>

<!-- Share link -->
@if (isPublished && assignment.shareCode) {
  <div class="border-t border-gray-200 mt-5 mb-3"></div>
  <p class="text-xs font-medium text-gray-600 mb-1.5">
    Share this link with students — their submissions will be graded
    automatically, and you'll see the results here.
  </p>
  <div
    class="flex items-center gap-1.5 px-2.5 py-1.5 bg-green-50 border border-green-100 rounded-md"
  >
    <lucide-icon
      [img]="icons.Link"
      class="w-3 h-3 text-green-500 shrink-0"
    ></lucide-icon>
    <span
      class="text-xs text-green-700 font-medium truncate flex-1 select-all"
      [title]="shareLink"
    >
      {{ shareLink }}
    </span>
    <button
      type="button"
      (click)="copyShareLink()"
      class="shrink-0 inline-flex items-center justify-center w-6 h-6 rounded bg-green-500 hover:bg-green-600 text-white transition-colors cursor-pointer"
      [title]="copied() ? 'Copied!' : 'Copy link'"
    >
      @if (copied()) {
        <lucide-icon
          [img]="icons.Check"
          class="w-3 h-3 text-green-600"
        ></lucide-icon>
      } @else {
        <lucide-icon [img]="icons.Copy" class="w-3 h-3"></lucide-icon>
      }
    </button>
  </div>

  <!-- Test as Student -->
  <div
    class="flex items-center justify-between gap-3 px-3 py-2 mt-3 bg-amber-50 border border-amber-200 rounded-lg"
  >
    <div class="flex items-center gap-2 min-w-0">
      <lucide-icon
        [img]="icons.FlaskConical"
        class="w-3.5 h-3.5 text-amber-500 shrink-0"
      ></lucide-icon>
      <span class="text-xs text-amber-700">
        Preview exactly what your students will see.
      </span>
    </div>
    <button
      type="button"
      (click)="onTestAsStudent()"
      class="shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold text-amber-700 bg-white border border-amber-300 hover:border-amber-400 hover:bg-amber-50 px-3 py-1.5 rounded-lg transition-colors cursor-pointer"
    >
      Test as Student
    </button>
  </div>
}
